import React, {useState, useEffect} from 'react'
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box';  
import DeleteIcon from '@mui/icons-material/Delete'; 
import EditIcon from '@mui/icons-material/Edit';
import Icon from '@mui/material/Icon'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions"
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
 import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsStoresNumSeriales = [
  {
    id: 'indexrowsnumseriales',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'store_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Store_Name',
    canOrder:true,
  },
  {
    id: 'substore_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SubStore_Name',
    canOrder:true,
  },
  {
    id: 'typeofsize_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_TypesOfSizeArticle',
    canOrder:true,
  },
  {
    id: 'color_codehex',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle',
    canOrder:false,
  },
  {
    id: 'color_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle_Show',
    canOrder:true,
  },
  {
    id: 'serialnumber',
    numeric: false,
    disablePadding: false,
    label: 'Text_NumSeriales_Article',
    canOrder:true,
  }
];

const headCellsStoresNumSerialesTypesOfSizes = [
  {
    id: 'indexrowsnumseriales',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'store_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Store_Name',
    canOrder:true,
  },
  {
    id: 'substore_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SubStore_Name',
    canOrder:true,
  },
  {
    id: 'typeofsize_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_TypesOfSizeArticle',
    canOrder:true,
  },
  {
    id: 'serialnumber',
    numeric: false,
    disablePadding: false,
    label: 'Text_NumSeriales_Article',
    canOrder:true,
  }
];

const headCellsStoresNumSerialesColors = [
  {
    id: 'indexrowsnumseriales',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'store_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Store_Name',
    canOrder:true,
  },
  {
    id: 'substore_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SubStore_Name',
    canOrder:true,
  },
  {
    id: 'color_codehex',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle',
    canOrder:false,
  },
  {
    id: 'color_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle_Show',
    canOrder:true,
  },
  {
    id: 'serialnumber',
    numeric: false,
    disablePadding: false,
    label: 'Text_NumSeriales_Article',
    canOrder:true,
  }
];

const headCellsStoresNumSerialesSimple = [
  {
    id: 'indexrowsnumseriales',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'store_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Store_Name',
    canOrder:true,
  },
  {
    id: 'substore_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SubStore_Name',
    canOrder:true,
  },
  {
    id: 'serialnumber',
    numeric: false,
    disablePadding: false,
    label: 'Text_NumSeriales_Article',
    canOrder:true,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,roles,formArticle } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_NumSeriales'))&&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 14}}>
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        { formArticle.applytypesofsize && formArticle.applycolor && headCellsStoresNumSeriales.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
        { formArticle.applytypesofsize && !formArticle.applycolor && headCellsStoresNumSerialesTypesOfSizes.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
        { !formArticle.applytypesofsize && formArticle.applycolor && headCellsStoresNumSerialesColors.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
         { !formArticle.applytypesofsize && !formArticle.applycolor && headCellsStoresNumSerialesSimple.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
       
        {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_NumSeriales'))&&
        <TableCell
          key='delete'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#e74a3b", fontSize: 14}} > 
            {t('Button_Delete')}
          </Typography>
        </TableCell>}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
    const { numTotRegStoresNumSerial, t, roles,setOpenEditNewStoresNumSerial,setOpenEditRowStoresNumSerial,formArticle} = props;
    const dispatch = useDispatch();

    const handleAddNewStoresNumSerial = () => { 
      if (formArticle.applytypesofsize && formArticle.applycolor){
        if (formArticle.articlesizes.length===0){
          dispatch(warningErrorAction(t('Text_Error_NotExistTypesOfSize')));
        }
        if (formArticle.articlecolors.length===0){
          dispatch(warningErrorAction(t('Text_Error_NotExistColors')));
        } 
        if (formArticle.articlesizes.length!==0 && formArticle.articlecolors.length!==0){
            setOpenEditNewStoresNumSerial(false);
            setOpenEditRowStoresNumSerial(true);
        }  
      }  else {
        if (formArticle.applytypesofsize && formArticle.articlesizes.length===0){
          dispatch(warningErrorAction(t('Text_Error_NotExistTypesOfSize')));
        } else{
          if (formArticle.applycolor && formArticle.articlecolors.length===0){
            dispatch(warningErrorAction(t('Text_Error_NotExistColors')));
          } else {
            setOpenEditNewStoresNumSerial(false);
            setOpenEditRowStoresNumSerial(true);
          }  
        }
      }  
    };

    return (
      <Toolbar>
      <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 14}} id="tableTitle" component="div">
        {t('Text_NumSeriales_ArticleStore')} &nbsp;&nbsp;
        { roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Add_NumSeriales')) &&
          <>
            <IconButton
              size="small"  
              style={{color:"#e74a3b", fontSize: 14}}
              onClick={handleAddNewStoresNumSerial}>
                <Icon
                  baseClassName="fas"
                  className="fa-plus add-icon-button"
                /> 
            </IconButton>&nbsp;&nbsp;
          </>
        }
      </Typography>
      <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 14}} id="tableTitle" component="div">
        {t('Text_Num_Reg')} {(numTotRegStoresNumSerial).toLocaleString('de-DE')} {t('Text_Of')}  {(numTotRegStoresNumSerial).toLocaleString('de-DE')}
      </Typography>
    </Toolbar>
  );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataArticles']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const TableSortingStoresNumSeriales =(props)=>{
  const { dataStoresNumSeriales,
    numTotRegStoresNumSerial, 
    setOpenDeleteRowStoresNumSerial,
    setOpenEditNewStoresNumSerial,
    setOpenEditRowStoresNumSerial,
    setEditRowStoreNumSerial,
    roles, 
    formArticle} = props;
  
  const {t,i18n} = useTranslation(['listDataArticles']);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderNumSerial] = React.useState('calories');
  const [page, setPageNumSerial] = React.useState(0);
  const [rowsPerPage, setRowsPerPageNumSerial] = useState(5);
  const [emptyRowsNumSerial, setEmptyRowsNumSerial] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStoresNumSeriales.length) : 0);
  const [countData,setCountData] = useState(dataStoresNumSeriales.length);
  const [activeOffsetNumSerial, setActiveOffsetNumSerial]= useState(false);
  const [currencyOffsetNumSerial, setCurrencyOffsetNumSerial] = useState(1);
  const [rangeOffsetNumSerial, setRangeOffsetNumSerial] = useState([{}]);

    useEffect(() => {
      if (dataStoresNumSeriales.length !== countData || dataStoresNumSeriales.length <= rowsPerPage) {
        setPageNumSerial(0);
      }  
      setCountData(dataStoresNumSeriales.length);
      setEmptyRowsNumSerial(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStoresNumSeriales.length) : 0);
    }, [dataStoresNumSeriales, rowsPerPage, page, countData]);
    
    useEffect(() => {
      if (numTotRegStoresNumSerial > LIMIT_PAGE) {
        setActiveOffsetNumSerial(true);
        const ranges = [
          {
            value: 1,
            label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
          },
        ];
        for (let i = Number(LIMIT_PAGE); i < numTotRegStoresNumSerial; i += Number(LIMIT_PAGE)) {
          ranges.push({
            value: (i / Number(LIMIT_PAGE)) + 1,
            label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
          });
        }
        setRangeOffsetNumSerial(ranges);
      } else {
        setCurrencyOffsetNumSerial(1);
        setActiveOffsetNumSerial(false);
        setRangeOffsetNumSerial([{}]);
      }
    }, [numTotRegStoresNumSerial]);

  const handleChangeOffset = (event) => {
    setCurrencyOffsetNumSerial(event.target.value);
  };

  const handleRequestSortNumSerial = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderNumSerial(property);
  };

  const handleChangePage = (event, newPage) => {
    setPageNumSerial(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPageNumSerial(parseInt(event.target.value, 10));
    setPageNumSerial(0);
  };

  const openModalDeleteRowStoresNumSeriales = (row) => {
    setEditRowStoreNumSerial(row);
    setOpenDeleteRowStoresNumSerial(true);
  };

  const openEditRowStoresNumSeriales = (row) => {
    setEditRowStoreNumSerial(row);
    setOpenEditNewStoresNumSerial(true);
    setOpenEditRowStoresNumSerial(true);
  };

  const listItemsNumSerial= (
  stableSort(dataStoresNumSeriales, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataStoresNumSeriales) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataStoresNumSeriales}>
        {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_NumSeriales')))&&
          <TableCell align="center">
            <IconButton size="large" className="edit-icon-button" onClick={()=>openEditRowStoresNumSeriales(row)}>
              <EditIcon/>
            </IconButton>
          </TableCell>
        }
        <TableCell align="right">
          <Typography style={{color:"#4e73df", fontSize: 14}} >
            {row.indexrowsnumseriales}
          </Typography>
        </TableCell>
         <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 14}} >
            {row.store_name}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 14}} >
            {row.substore_name}
          </Typography>
        </TableCell>

        {formArticle.applytypesofsize &&
          <TableCell align="left">
            <Typography style={{color:"#4e73df", fontSize: 14}} >
              {row.typeofsize_id===null?t('Text_Filter_notapplytypesofsize'):(i18n.language==="es"?row.typeofsize_namees:row.typeofsize_nameen)}
            </Typography>
          </TableCell>
        }
        {formArticle.applycolor &&
          <TableCell align="center">
              <Box sx={{ align: 'center', width: 60, height: 15, backgroundColor: row.color_codehex}}/>
          </TableCell>
        }
        {formArticle.applycolor &&
          <TableCell align="left">
            <Typography style={{color:"#4e73df", fontSize: 14}} >
              {row.color_id===null?t('Text_Filter_notapplycolor'):(i18n.language==="es"?row.color_namees:row.color_nameen)}
            </Typography>
          </TableCell>
        }
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 14}} >
            {row.serialnumber}
          </Typography>
        </TableCell>
       
        {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_NumSeriales'))) &&
        <TableCell align="center">
          <IconButton size="large" className="delete-icon-button" onClick={()=>openModalDeleteRowStoresNumSeriales(row)}>
            <DeleteIcon/>
          </IconButton>
        </TableCell>}
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar numTotRegStoresNumSerial={numTotRegStoresNumSerial} t={t} roles={roles} setOpenEditNewStoresNumSerial={setOpenEditNewStoresNumSerial} setOpenEditRowStoresNumSerial={setOpenEditRowStoresNumSerial} formArticle={formArticle}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '1060px',width: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSortNumSerial} t={t} roles={roles} formArticle={formArticle}/>
              <TableBody>    
                {listItemsNumSerial}
                {emptyRowsNumSerial > 0 && (
                <TableRow style={{ height: 33  * emptyRowsNumSerial}}>
                  <TableCell colSpan={12} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetNumSerial && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetNumSerial"
                            name="currencyOffsetNumSerial"
                            value={currencyOffsetNumSerial}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetNumSerial
                            }}>
                            {rangeOffsetNumSerial.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={17}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingStoresNumSeriales.propTypes = {
  dataStoresNumSeriales: PropTypes.array.isRequired, 
  numTotRegStoresNumSerial: PropTypes.number.isRequired,
  setOpenDeleteRowStoresNumSerial: PropTypes.func.isRequired,
  setOpenEditNewStoresNumSerial: PropTypes.func.isRequired,
  setOpenEditRowStoresNumSerial: PropTypes.func.isRequired,
  setEditRowStoreNumSerial: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired
};

export default TableSortingStoresNumSeriales;